// extracted by mini-css-extract-plugin
export default {"title":"Advt_title__LLpkd","nominations":"Advt_nominations__1zfLN","shadow":"Advt_shadow__mriat","label":"Advt_label__+2P-F"};